import { useMemo, useState } from 'react';
import { hotList } from '../../../mocks/guaData';

const tabs = [
  { key: '全部', label: '全部热瓜' },
  { key: '爆', label: '爆点' },
  { key: '热', label: '高热' },
  { key: '新', label: '最新' },
];

const medal = ['bg-primary-500 text-background-50', 'bg-accent-500 text-background-50', 'bg-secondary-600 text-background-50'];

export default function HotRank() {
  const [tab, setTab] = useState('全部');

  const list = useMemo(() => {
    if (tab === '全部') return hotList;
    return hotList.filter((it) => it.tag === tab);
  }, [tab]);

  return (
    <section id="hot" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-accent-600">Daily Trend</p>
          <h3 className="mt-2 flex items-center gap-2 text-2xl font-black text-foreground-950 md:text-3xl">
            <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
            今日热榜 TOP10
          </h3>
          <p className="mt-2 text-sm text-foreground-600">按热度实时排序，想快速吃完当天的瓜就看这里</p>
        </div>

        {/* segmented control */}
        <div role="tablist" aria-label="热榜筛选" className="inline-flex rounded-full bg-background-200 p-1">
          {tabs.map((t) => (
            <button
              key={t.key}
              role="tab"
              aria-selected={tab === t.key}
              onClick={() => setTab(t.key)}
              className={`cursor-pointer rounded-full px-5 py-2 text-sm font-semibold transition ${
                tab === t.key ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <ol className="mt-8 grid gap-3 lg:grid-cols-2">
        {list.map((it, i) => (
          <li key={it.rank}>
            <article className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition hover:border-primary-200 hover:bg-primary-50/40">
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-base font-black ${
                  i < 3 ? medal[i] : 'bg-background-100 text-foreground-600'
                }`}
              >
                {it.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span
                    className={`rounded px-1.5 py-0.5 text-[11px] font-bold ${
                      it.tag === '爆'
                        ? 'bg-primary-100 text-primary-700'
                        : it.tag === '热'
                        ? 'bg-accent-100 text-accent-800'
                        : 'bg-secondary-100 text-secondary-800'
                    }`}
                  >
                    {it.tag}
                  </span>
                  <p className="truncate text-sm font-bold text-foreground-900 group-hover:text-primary-700">{it.title}</p>
                </div>
              </div>
              <div className="hidden shrink-0 flex-col items-end sm:flex">
                <span className="font-black text-primary-600">{it.heat.toFixed(1)}</span>
                <span className="text-[11px] text-foreground-400">万热度</span>
              </div>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-400 transition group-hover:bg-primary-500 group-hover:text-background-50">
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </article>
          </li>
        ))}
      </ol>

      <p className="mt-6 text-center text-xs text-foreground-500">
        榜单每小时更新 · 点击条目进入「热闻速览」查看详情
      </p>
    </section>
  );
}